import React from 'react';
import HireDevelopers from '../common/HireDevelopers';

const EmoteEngineer = () => {
  return (
    <section className="bg-black !pt-[60px] lg:pt-[150px] !pb-[50px] md:!pb-[100px]">
      <div className="max-width --layout-padding">
        <div className="emotEngieerCon">
          <h2 className="text-[30px] lg:text-55 text-center font-semibold">Remote Engineers Who Anticipate, Adapt, and <span className='text-[#0090FF]'>Execute</span> </h2>
          <p className='text-center my-[12px]'>90%+ Of developers have worked on enterprise-grade systems or funded startups</p>
          <div className="mt-[30px]">
            <ul className='flex flex-col gap-[20px] md:grid md:grid-cols-3 lg:gap-0'>
              <li className=''>
                <h3 className='text-[2rem] font-bold text-center lg:text-left'>Code Quality <br className='hidden lg:block' /> First</h3>
                <p className='text-[0.8rem] text-center lg:text-left lg:pr-[20px]'>All developers follow clean code principles, CI/CD practices, and test automation </p>
              </li>
              <li className='lg:border-l lg:border-[#787878] lg:pl-[30px]'>
                <h3 className='text-[2rem] font-bold text-center lg:text-left'>Language <br className='hidden lg:block' /> Proficiency </h3>
                <p className='text-[0.8rem] text-center lg:text-left lg:pr-[20px]'>All engineers communicate fluently in English—ensuring zero communication barriers</p>
              </li>
              <li className='lg:border-l lg:border-[#787878] lg:pl-[30px]'>
                <h3 className='text-[2rem] font-bold text-center lg:text-left'>Niche Skills <br className='hidden lg:block' /> Available</h3>
                <p className='text-[0.8rem] text-center lg:text-left lg:pr-[20px]'>From AI/ML to blockchain, cybersecurity, and IoT—experts in both mainstream and emerging tech</p>
              </li>
            </ul>
          </div>
          <HireDevelopers/>
        </div>
      </div>
    </section>
  );
};

export default EmoteEngineer;